import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export const NodeImage = ({ node, attributes }) => {
    return (_jsx(Box, { component: "img", "data-testid": `node/image/${attributes.id}`, src: attributes.src, alt: node.meta.label?.text }));
};
